import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

const TabNavigation = ({ activeTab, onTabChange, hasUnsavedChanges = {} }) => {
  const tabs = [
    {
      id: 'business-details',
      label: 'Business Details',
      icon: 'Building2',
      description: 'Business information and branding'
    },
    {
      id: 'operating-hours',
      label: 'Operating Hours',
      icon: 'Clock',
      description: 'Schedule and availability'
    },
    {
      id: 'contact-info',
      label: 'Social Media Information',
      icon: 'Phone',
      description: 'Business social media accounts'
    },
    {
      id: 'location-settings',
      label: 'Location Settings',
      icon: 'MapPin',
      description: 'Address and service area'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-2">
      {/* Desktop Tab Navigation */}
      <div className="hidden lg:flex space-x-1">
        {tabs?.map((tab) => (
          <Button
            key={tab?.id}
            variant={activeTab === tab?.id ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onTabChange(tab?.id)}
            className={`flex-1 justify-start transition-smooth relative rounded py-6 ${
              activeTab === tab?.id 
                ? 'bg-primary text-primary-foreground shadow-sm' 
                : 'hover:bg-primary/90 hover:text-primary'
            }`}
          >
            <Icon 
              name={tab?.icon} 
              size={16} 
              className={`mr-2 ${
                activeTab === tab?.id 
                  ? 'text-primary-foreground' 
                  : 'text-muted-foreground'
              }`}
            />
            <div className="text-left">
              <div className="font-medium text-sm">{tab?.label}</div>
              <div className={`text-xs ${
                activeTab === tab?.id 
                  ? 'text-primary-foreground/80' 
                  : 'text-muted-foreground'
              }`}>
                {tab?.description}
              </div>
            </div>
            
            {/* Unsaved changes indicator */}
            {hasUnsavedChanges?.[tab?.id] && (
              <div className="absolute -top-1 -right-1 w-2 h-2 bg-warning rounded-full"></div>
            )}
          </Button>
        ))}
      </div>
      {/* Mobile Tab Navigation */}
      <div className="lg:hidden">
        <div className="flex overflow-x-auto space-x-1 pb-2">
          {tabs?.map((tab) => (
            <Button
              key={tab?.id}
              variant={activeTab === tab?.id ? 'default' : 'ghost'}
              size="sm"
              onClick={() => onTabChange(tab?.id)}
              className={`flex-shrink-0 transition-smooth relative ${
                activeTab === tab?.id 
                  ? 'bg-primary text-primary-foreground' 
                  : 'hover:bg-muted'
              }`}
            >
              <Icon 
                name={tab?.icon} 
                size={16} 
                className={`mr-2 ${
                  activeTab === tab?.id 
                    ? 'text-primary-foreground' 
                    : 'text-muted-foreground'
                }`}
              />
              <span className="font-medium text-sm whitespace-nowrap">
                {tab?.label}
              </span>
              
              {/* Unsaved changes indicator */}
              {hasUnsavedChanges?.[tab?.id] && (
                <div className="absolute -top-1 -right-1 w-2 h-2 bg-warning rounded-full"></div>
              )}
            </Button>
          ))}
        </div>

        {/* Active tab description for mobile */}
        <div className="mt-2 p-3 bg-muted/30 rounded-lg">
          <div className="flex items-center space-x-2">
            <Icon 
              name={tabs?.find(tab => tab?.id === activeTab)?.icon} 
              size={16} 
              className="text-primary" 
            />
            <span className="text-sm text-muted-foreground">
              {tabs?.find(tab => tab?.id === activeTab)?.description}
            </span>
          </div>
        </div>
      </div>
      {/* Tab Progress Indicator */}
      <div className="mt-4 flex items-center justify-between text-xs text-muted-foreground">
        <span>
          {tabs?.findIndex(tab => tab?.id === activeTab) + 1} of {tabs?.length}
        </span>
        <div className="flex space-x-1">
          {tabs?.map((tab, index) => (
            <div
              key={tab?.id}
              className={`w-2 h-2 rounded-full transition-colors ${
                index <= tabs?.findIndex(t => t?.id === activeTab)
                  ? 'bg-primary' :'bg-muted'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TabNavigation;